package pwgs.ui.scenes.playerscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class APlayerSceneControllerFe(props: pwgs.ui.scenes.playerscene.PlayerSceneProps, scene: MPlayerSceneScene)
 : AController<pwgs.ui.scenes.playerscene.PlayerSceneProps, pwgs.ui.scenes.playerscene.PlayerSceneModel, PlayerSceneSceneState>(props, scene) {

    val backend = PlayerSceneControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_ban() {
        launchOnDefaultControllerScope {
            render(backend.ban())
        }
    }

    fun call_unban() {
        launchOnDefaultControllerScope {
            render(backend.unban())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class PlayerSceneControllerBeProxy(private val controller: APlayerSceneControllerFe) {

    suspend fun load(): pwgs.ui.scenes.playerscene.PlayerSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.playerscene.PlayerSceneControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.playerscene.PlayerSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.playerscene.PlayerSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.playerscene.PlayerSceneModel.serializer())
        }
    }

    suspend fun ban(): pwgs.ui.scenes.playerscene.PlayerSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.playerscene.PlayerSceneControllerBe.ban",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.playerscene.PlayerSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.playerscene.PlayerSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.playerscene.PlayerSceneModel.serializer())
        }
    }

    suspend fun unban(): pwgs.ui.scenes.playerscene.PlayerSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.playerscene.PlayerSceneControllerBe.unban",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.playerscene.PlayerSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.playerscene.PlayerSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.playerscene.PlayerSceneModel.serializer())
        }
    }

}
